export const BUTTONSTYLE = {
    padding: '10px',
    borderRadius: '10px',
    fontWeight: 'bold',
    border: 'solid thin #707070',
    backgroundColor: 'white',
    outline: 'none'
}